import { Component, Inject, Optional, OnInit, ViewChild, Input, EventEmitter, Output, HostListener, ViewChildren, QueryList, AfterViewInit, AfterViewChecked, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { collapsibleTabla2abm } from './collapsible.animation';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpService } from '../http.service';
import { NumformPipe } from '@tres-erres/ngx-utils';
import { merge } from 'rxjs/internal/observable/merge';
import { startWith, switchMap, map } from 'rxjs/operators';
import { ColumnaTabla2abm, Tabla2abmPrefs } from './interfaces';
import { ComponentesService } from '../componentes.service';
import { Accion } from '../interfaces';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { FocusNextDirective } from '../directives/focus-next.directive';
import { InputBS } from '../inputbs/inputbs.component';


/**
 * TODO: Que loading saque offset de tabla2abm para asignar top, bottom, left y right
 */
@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-tabla2abm',
	templateUrl: './tabla2abm.component.html',
	styleUrls: ['./tabla2abm.component.scss'],
	animations: [ collapsibleTabla2abm ],
	encapsulation: ViewEncapsulation.None
})
export class Tabla2abm implements OnInit, AfterViewInit, AfterViewChecked {
	constructor(
		private httpService: HttpService,
		private componentesService: ComponentesService,
		private fb: FormBuilder,
		@Optional() @Inject('baseUrl') private baseUrl: string,
		private bottomSheet: MatBottomSheet
	) {
		if (!this.httpService['baseUrl'] && (!this.baseUrl || this.baseUrl.length === 0)) {
			throw new Error('No está definida la constante baseUrl');
		} else {
			if (this.baseUrl && this.baseUrl.length > 0) {
				this.httpService['baseUrl'] = this.baseUrl;
			}
			this.actualizarHeaders();
		}
	}
	inicializado = false;
	headers = [];
	dataSource = new MatTableDataSource();
	resultsLength = 0;
	isLoading = false;
	browserRequest;
	itemsSeleccionados = { ids: [], denominacion: [] };
	columna = null;
	direccion = null;
	permisos: any = {};

	columnas: ColumnaTabla2abm[] = [];
	formulario: FormGroup;
	url: string;
	metodo = 'POST';
	resetOnSubmit = true;
	campoID: string;

	/** Permite habilitar o no los botones de Guardar y Cancelar del formulario */
	@Input() btnAcciones = true;

	@Output() fnchipChanges = new EventEmitter();
	@Output() fnestablecido = new EventEmitter();
	@Output() fncambiaFecha = new EventEmitter();
	@Output() fncambiaMes = new EventEmitter();
	@Output() fncambiaSelect = new EventEmitter();

	@Input() nombreDatos = 'todos';

	@Input() nombreCuantas = 'cuantas';

	/** Resultados por página */
	@Input() cuantos = 10;

	@Input() urlGetDatos?: string;

	/** Si está contenido en un sidenav, por scrolling */
	@Input() sidenav = false;

	/** Si cambia pagina al mover la rueda */
	@Input() scrollable = true;

	/** Si realiza las peticiones por POST, caso contrario, GET */
	@Input() post = true;

	@Input() mostrarPeso = false;

	/** Permite desactivar la ordenacion de la tabla2abm */
	@Input() sortable = true;

	/** Formulario personalizado para el buscador */
	@Input() customFormGroup: FormGroup;

	/** Deshabilita el buscador por defecto */
	@Input() ocultaBuscador = false;

	/** Placeholder del campo de búsqueda */
	@Input() placeholder = 'Buscar...';

	/** Array de resultados predefinidos, comunmente utilizados para cuando chips es true */
	@Input() resultadosChips: any[] = [];

	/** Cantidad de caracteres minimos necesarios para que el autocomplete arroje resultados */
	@Input() min = 1;

	/** Configura la búsqueda por chips */
	@Input() chips = false;

	/** Si muestra checkbox y emite eventos */
	@Input() selecciona = false;

	/** Nombre del campo que referencia al id. Ej: "ctid" */
	@Input() nombreCampoId = 'id';

	/** Nombre del campo que referencia al nombre. Ej: "ctnombre" */
	@Input() nombreCampoDenominacion = 'denominacion';

	/** Retornar el objeto completo al seleccionar  */
	@Input() retornarObjetoCompleto = false;

	/** "Elementos seleccionados": 1 */
	@Input() nombreElementosSeleccionados = 'Elementos seleccionados';

	/** Array de acciones (tabla2abm primaria) */
	@Input() acciones: Accion[] = [];

	/** Si muestra un toggle como acción en cada fila  */
	@Input() toggle = null;

	/** Define la cantidad de iconos a mostrar antes de agrupar */
	@Input() maxIconosVisibles ? = 4;

	/** Emite evento cada vez que cambian los itemsSeleccionados */
	@Output() seleccion = new EventEmitter();

	@ViewChildren(FocusNextDirective) focusElements: QueryList<FocusNextDirective>;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	// @ViewChild('matTable') matTable: MatTable<any>;
	@ViewChildren(MatMenuTrigger) matMenuTriggers: QueryList<MatMenuTrigger>;
	/** Función que brinda el componente padre para modificar los datos al refrescar */
	@Input() modificarDatos: Function = (datos) => datos;

	/** Función que brinda el componente padre para obtener los parámetros de la query */
	@Input() getDatos: Function = () => Object.create({});

	/** Formatea la respuesta que llega de la petición */
	@Input() formateaRespuesta: Function = (data) => data;

	antesSubmit: () => Promise<void> = () => Promise.resolve();
	despuesSubmit: () => Promise<void> = () => Promise.resolve();

	ngOnInit() {
		this.formulario = this.fb.group({});
		setTimeout(() => {
			this.inicializado = this.columnas && this.columnas.length > 0;
		});
	}

	async ngAfterViewInit() {
		await this.ngAfterViewChecked();
		return;
	}

	async ngAfterViewChecked() {
		return;
	}

	init(datos: Tabla2abmPrefs) {
		return new Promise(resolve => {
			// this.isLoading = true;
			this.ngAfterViewInit().then(() => {
				this.actualizarDatos(datos, false);
/*
				// inicializamos el formulario
				if (datos.metodo) {
					this.metodo = datos.metodo;
				}

				if (datos.resetOnSubmit != undefined && datos.resetOnSubmit != null) {
					this.resetOnSubmit = datos.resetOnSubmit;
				}

				if (datos.antesSubmit) {
					this.antesSubmit = datos.antesSubmit;
				}

				if (datos.despuesSubmit) {
					this.despuesSubmit = datos.despuesSubmit;
				}

				this.campoID = datos.campoID;
				this.url = datos.url;
				this.columnas = datos.columnas;
*/
				if (this.columnas && this.columnas.length > 0) {
					for (let i = 0; i < this.columnas.length; i++) {
						this.formulario.addControl(this.columnas[i].def, new FormControl(null));
						this.formulario.get(this.columnas[i].def)['tipo'] = this.columnas[i].tipo;
						this.formulario.get(this.columnas[i].def)['attrs'] = this.columnas[i].attrs;
						this.columnas[i]['rowIndex'] = null;
						if (this.columnas[i].validadores) {
							this.formulario.get(this.columnas[i].def).setValidators(this.columnas[i].validadores);
						}
					}
				}
				setTimeout(() => {
					const ele = this.focusElements.find(f => f.tabIndex === Math.min(...this.focusElements.map(f => f.tabIndex)));
					if (ele) {
						ele.focus();
					}
				});

				// inicializamos la tabla
				if (!this.urlGetDatos || this.urlGetDatos == '') {
					this.setDatos();
					this.dataSource.data = this.rellenar([]);
					this.inicializado = true;
					resolve();
					return;
				}
				merge(this.paginator.page)
				.pipe(
					startWith({}),
					switchMap(() => {
						this.isLoading = true;
						const data = this.setDatos();
						let req: Promise<any>;
						if (this.post) {
							req = this.httpService.post(this.urlGetDatos, data);
						} else {
							req = this.httpService.get(this.urlGetDatos, data);
						}
						return req;
					}),
					map((data: any) => {
						data = this.formateaRespuesta(data);
						this.isLoading = false;
						if (data) {
							this.resultsLength = (this.nombreCuantas && data[this.nombreCuantas]) ? data[this.nombreCuantas] : (data.cuantas ? data.cuantas : 0);
							this.permisos = data.permisos ? data.permisos : {};
							return this.nombreDatos && data[this.nombreDatos] ? data[this.nombreDatos] : data;
						} else {
							console.error('No hubo respuesta del servidor');
							return [];
						}
					})
				).subscribe(datos => {
					datos = datos ? this.modificarDatos(datos) : [];
					if (datos.length < this.cuantos && datos.length > 0) {
						this.dataSource.data = this.rellenar(datos);
					} else {
						this.dataSource.data = datos;
					}
					this.inicializado = true;
					resolve();
				});
			});
		});
	}

	/**
	 * quepagina: a que página ir.
	 *
	 */

	irPagina(quepagina) {
		this.paginator.pageIndex = quepagina;
	}

	actualizarDatos(datos, refresh?: boolean) {
		for (const key in datos) {
			if (datos.hasOwnProperty(key)) {
				const dato = datos[key];
				this[key] = dato;
			}
		}
		this.firstPage();
		if (refresh === false) {
			return;
		}
		if (this.inicializado) {
			this.refreshTable(false);
		}
	}

	actualizarHeaders() {
		// vemos si existe una columna de selección
		let hayColumnaSeleccion = false;
		let indexColumnaSeleccion = 0;
		for (let i = 0; i < this.columnas.length; i++) {
			if (this.columnas[i].def == 'seleccion') { hayColumnaSeleccion = true; }
			indexColumnaSeleccion = i;
			break;
		}

		if (this.selecciona && !hayColumnaSeleccion) {
			this.columnas.unshift({def: 'seleccion', nombre: 'Selección', tipo: null});
		} else if (!this.selecciona && hayColumnaSeleccion) {
			// elimino la columna de selección
			this.columnas.splice(indexColumnaSeleccion, 1);
		}

		this.headers = this.columnas.map((columna) => {
			return columna.def;
		});
		this.cargarAnchos();
	}

	setDatos() {
		const datos = this.getDatos();

		if (!datos.cuantos) {
			datos.cuantos = this.cuantos;
		}
		if (!datos.texto) {
			// Esto deberá pasar a ser entradas de un formulario.
			// Por defecto tenemos una entrada, pero podrían ser varias.
			// Decidimos dejar a que el backend se encargue y solamente le pasamos el objeto value del formGroup
			datos.texto = '';
		}
		if (this.paginator) {
			datos.pag = this.paginator.pageIndex;
			if (this.paginator.pageSize != datos.cuantos) {
				datos.cuantos = this.paginator.pageSize;
			}
		} else {
			datos.pag = 0;
		}
		datos.columna = this.columna;
		datos.direccion = this.direccion;
		this.actualizarHeaders();
		return datos;
	}

	refreshTable(saltear_espera?: Boolean) {
		this.isLoading = true;
		clearTimeout(this.browserRequest);
		this.browserRequest = setTimeout(() => {
			let req: Promise<any>;
			if (this.post) {
				req = this.httpService.post(this.urlGetDatos, this.setDatos());
			} else {
				req = this.httpService.get(this.urlGetDatos, this.setDatos());
			}
			req.then(data => {
				data = this.formateaRespuesta(data);
				this.resultsLength = this.nombreCuantas ? data[this.nombreCuantas] : (data.cuantas ? data.cuantas : 0);
				this.permisos = data.permisos ? data.permisos : {};
				data = this.nombreDatos && data[this.nombreDatos] ? data[this.nombreDatos] : data;
				data = data ? this.modificarDatos(data) : [];
				if (data.length < this.cuantos && data.length > 0) {
					this.dataSource.data = this.rellenar(data);
				} else {
					this.dataSource.data = data;
				}
				this.isLoading = false;
				if (this.resultsLength <= this.paginator.pageSize * this.paginator.pageIndex) {
					this.firstPage();
				}
			});
		}, saltear_espera ? 0 : 400);
	}
	chipChanges(e) {
		const valor = e[e.length - 1];
		if (this.chips && valor && !valor._deAuto) {
			// this.filtraFormGroup.get('buscar').patchValue(e);
			this.refreshTable();
		}
	}
	vaciarTabla2abm() {
		this.dataSource.data = [];
		this.resultsLength = 0;
	}
	llenarTabla2abm (datos: any) {
		if (datos && datos.length > 0) {
			if (datos.length < this.cuantos) {
				this.dataSource.data = this.rellenar(datos);
			} else {
				this.dataSource.data = datos;
			}
		} else {
			this.dataSource.data = [];
		}
	}
	rellenar(datos) {
		const rows = [];
		datos.forEach(element => {
			rows.push(element);
		});
		const cantidad = rows.length;
		for (let i = 0; i < (this.cuantos - cantidad); i++) {
			const obj = {};
			this.columnas.forEach(col => {
				obj[col.def] = null;
			});
			rows.push(obj);
		}
		return rows;
	}

	estaVacio(element) {
		// console.log(Object.values(element).every((item) => item === null));
		return false; // Object.values(element).every((item) => item === null);
	}

	cambiaOrden(event) {
		if (event.direction.length > 0) {
			this.columna = event.active;
			this.direccion = event.direction;
		} else {
			this.columna = null;
			this.direccion = null;
		}
		this.refreshTable(true);
	}

	numForm(valor, borrarceros) {
		return new NumformPipe().transform(valor, borrarceros);
	}

	// Abre el menu contextual de la cabecera de la tabla2abm
	menuHeader(columna, event) {
		event.preventDefault();
		this.matMenuTriggers.forEach((trigger) => {
			if (trigger.menuData && trigger.menuData.columna === columna) {
				trigger.openMenu();
			}
		});
	}

	modificaAncho(columna, oper, event) {
		event.stopPropagation();
		if (!columna.ancho) {
			this.columnas.forEach(col => {
				if (col !== columna) {
					col.ancho = Math.floor(100 / this.columnas.length);
				}
				this.guardaAnchos(col);
			});
			columna.ancho = Math.floor(100 / this.columnas.length) + ((oper === 'mas') ? 1 : -1);
		} else {
			columna.ancho += (oper === 'mas') ? 1 : -1;
		}
		this.guardaAnchos(columna, oper);
	}

	borraAncho(columna) {
		if (columna.ancho) {
			const anchosTabla2abms: any = JSON.parse(localStorage.getItem('anchosTabla2abms'));
			this.columnas.forEach(col => {
				if (col === columna) {
					if (anchosTabla2abms[this.urlGetDatos] && anchosTabla2abms[this.urlGetDatos][columna.def] && anchosTabla2abms[this.urlGetDatos][columna.def]['original']) {
						col.ancho = anchosTabla2abms[this.urlGetDatos][columna.def]['original'];
						delete anchosTabla2abms[this.urlGetDatos][columna.def];
						localStorage.setItem('anchosTabla2abms', JSON.stringify(anchosTabla2abms));
					}
				}
			});
		}
	}

	guardaAnchos(columna, oper?) {
		let anchosTabla2abms: any = localStorage.getItem('anchosTabla2abms');
		if (!anchosTabla2abms) {
			anchosTabla2abms = {};
		} else {
			anchosTabla2abms = JSON.parse(anchosTabla2abms);
		}
		this.columnas.forEach((col) => {
			if (col === columna) {
				if (!anchosTabla2abms[this.urlGetDatos]) {
					anchosTabla2abms[this.urlGetDatos] = {};
				}
				if (!anchosTabla2abms[this.urlGetDatos][columna.def]) {
					anchosTabla2abms[this.urlGetDatos][columna.def] = {};
				}
				if (!anchosTabla2abms[this.urlGetDatos][columna.def]['original']) {
					anchosTabla2abms[this.urlGetDatos][columna.def]['original'] = columna.ancho;
					if (oper) {
						anchosTabla2abms[this.urlGetDatos][columna.def]['original'] += (oper === 'mas') ? -1 : 1;
					}
				}
				anchosTabla2abms[this.urlGetDatos][columna.def]['modificado'] = columna.ancho;
			}
		});
		localStorage.setItem('anchosTabla2abms', JSON.stringify(anchosTabla2abms));
	}

	cargarAnchos() {
		let anchosTabla2abms: any = localStorage.getItem('anchosTabla2abms');
		if (!anchosTabla2abms) {
			return;
		} else {
			anchosTabla2abms = JSON.parse(anchosTabla2abms);
		}
		this.columnas.forEach((col) => {
			if (anchosTabla2abms[this.urlGetDatos] && anchosTabla2abms[this.urlGetDatos][col.def] !== undefined) {
				col.ancho = anchosTabla2abms[this.urlGetDatos][col.def]['modificado'];
			}
		});
	}

	clasesRow(row) {
		const clases = {
			'fila-expandible': false, // this.detalla,
			'fila-expandida': false, // this.expandedElement.indexOf(row) !== -1,
			'editando': row.editando
		};
		if (row.clase) {
			if (typeof row.clase === 'string') {
				clases[row.clase] = true;
			} else {
				row.clase.forEach(element => {
					clases[element] = true;
				});
			}
		}
		return clases;
	}

	firstPage() {
		this.ngAfterViewInit().then(() => {
			this.paginator.firstPage();
		});
	}

	@HostListener('wheel', ['$event']) // Firefox
	@HostListener('mousewheel', ['$event']) // Chrome
	onScroll(event) {
		// if (!this.hayScroll(this.sidenav) && this.scrollable && this.expandedElement.length === 0) {
		// 	if ((event.target.className instanceof SVGAnimatedString || this.parents(event.target, '.mat-table') || event.target.className.includes('loading')) && (!this.hayScroll() && !this.hayScroll(true))) {
		// 		event.preventDefault();
		// 		if (event.deltaY < 0 && this.paginator.hasPreviousPage()) {
		// 			this.paginator.pageIndex--;
		// 			this.refreshTable();
		// 		} else if (event.deltaY > 0 && this.paginator.hasNextPage()) {
		// 			event.preventDefault();
		// 			this.paginator.pageIndex++;
		// 			this.refreshTable();
		// 		}
		// 	}
		// }
	}

	private hayScroll(sidenav?: boolean) {
		if (sidenav) {
			return document.querySelector('tr2-tabla2abm').clientHeight + 64 > window.innerHeight;
		} else {
			return document.body.clientHeight > window.innerHeight;
		}
	}

	private parents(element: string | any, parent: string) {
		let el: any = typeof element === 'string' ? document.querySelector(element) : element;
		const parents = Array.from(document.querySelectorAll(parent));
		while (el.tagName !== 'HTML') {
			el = el.parentNode;
			if (parents.indexOf(el) !== -1) {
				return el;
			}
		}
		return null;
	}

	/**
	 * preSeleccionar ids
	 * @param queids : array de ids a marcar
	 */
	preSeleccionar(queids) {
		// this.itemsSeleccionados.ids = [];
		// this.itemsSeleccionados.denominacion = [];
		this.dataSource.data.forEach((element: any) => {
			if (queids.indexOf(element[this.nombreCampoId]) >= 0) {
				if (this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) < 0) {
					if (this.retornarObjetoCompleto) {
						this.itemsSeleccionados.ids.push(element);
					} else {
						this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
						this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
					}
				}
			}
		});
	}

	marcar(que) {
		if (que === 'reiniciar') {
			this.itemsSeleccionados.ids = [];
			this.itemsSeleccionados.denominacion = [];
		} else {
			if (que === 'todas') {
				const datos = this.setDatos();
				datos.ids = null;
				this.isLoading = true;
				this.httpService.post(this.urlGetDatos, datos).then(data => {
					this.isLoading = false;
					const arrDatos = this.nombreDatos && data[this.nombreDatos] ? data[this.nombreDatos] : data;
					if (arrDatos) {
						arrDatos.forEach((element: any) => {
							if (this.retornarObjetoCompleto) {
								if (!this.itemsSeleccionados.ids.find(x => x[this.nombreCampoId] == element[this.nombreCampoId])) {
									this.itemsSeleccionados.ids.push(element);
								}
							} else {
								if (this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) < 0) {
									this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
									this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
								}
							}
						});
					}
				});
			} else if (que === 'pagina') {
				this.dataSource.data.forEach((element: any) => {
					if (element[this.nombreCampoId]) {
						if (this.retornarObjetoCompleto) {
							if (!this.itemsSeleccionados.ids.find ( x => x[this.nombreCampoId] == element[this.nombreCampoId])) {
								this.itemsSeleccionados.ids.push(element);
							}
						} else if (this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) < 0) {
								this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
								this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
						}
					}
				});
			}
		}
		this.seleccion.emit(this.itemsSeleccionados);
	}

	check(element: any, checked: boolean) {
		if (checked) {
			if (this.retornarObjetoCompleto) {
				this.itemsSeleccionados.ids.push(element);
			} else {
				this.itemsSeleccionados.ids.push(element[this.nombreCampoId]);
				this.itemsSeleccionados.denominacion.push(element[this.nombreCampoDenominacion]);
			}
		} else {
			if (this.retornarObjetoCompleto) {
				this.itemsSeleccionados.ids = this.itemsSeleccionados.ids.filter((item) => {
					return element[this.nombreCampoId] !== item[this.nombreCampoId];
				});
			} else {
				this.itemsSeleccionados.ids = this.itemsSeleccionados.ids.filter((item, index) => {
					if (element[this.nombreCampoId] === item) {
						delete this.itemsSeleccionados.denominacion[index];
					}
					return element[this.nombreCampoId] !== item;
				});
			}
		}
		this.seleccion.emit(this.itemsSeleccionados);
	}

	checked(element: any) {
		if (this.retornarObjetoCompleto) {
			return this.itemsSeleccionados.ids.find ((item) => item[this.nombreCampoId] === element[this.nombreCampoId]);
		} else {
			return this.itemsSeleccionados.ids.indexOf(element[this.nombreCampoId]) >= 0;
		}
	}

	preview() {
		if (this.itemsSeleccionados.ids.length > 20) {
			return '';
		} else {
			let title = '';
			this.itemsSeleccionados.denominacion.forEach(element => {
				title += element + `
`;
			});
			return title;
		}
	}

	onSubmit() {
		return new Promise(resolve => {

			// fix valor string cero
			for (const campo in this.formulario.value) {
				if (this.formulario.get(campo)['tipo'] == 'toggle' || this.formulario.get(campo)['tipo'] == 'checkbox') {
					this.formulario.get(campo).patchValue((this.formulario.get(campo).value == undefined || this.formulario.get(campo).value == null || this.formulario.get(campo).value == 0) ? false : this.formulario.get(campo).value);
				}
			}

			this.antesSubmit().then(() => {
				if (this.url && this.url != '') {
					this.httpService.post(this.url, {campoID: this.campoID, datos: this.formulario.value}).then((data) => {
						if (data.ok === 1) {

							// mostramos notificacion de exito
							this.componentesService.notification('Datos guardados satisfactoriamente.');

							// funcion despues de enviado el formulario
							this.despuesSubmit().then(() => {
								// limpiamos el formulario
								if (this.resetOnSubmit) {
									this.reset();
								}
								resolve(true);
							})
							.catch( (e) => {
								console.log('Despues Submit', e);
							});
						} else {
							// mostramos notificacion de fallo
							this.componentesService.notification((data.msg) ? data.msg : 'Error al guardar los datos.');
							resolve(false);
						}
					})
					.catch((e) => {
						console.log(e);
						// mostramos notificacion de fallo
						this.componentesService.notification('Error al guardar los datos.');
						resolve(false);
					});
				} else {
					// funcion despues de enviado el formulario
					this.despuesSubmit().then(() => {
						// limpiamos el formulario
						if (this.resetOnSubmit) {
							this.reset();
						}
						resolve(false);
					})
					.catch( (e) => {
						console.log('Despues Submit', e);
					});
				}
			})
			.catch(e => {
				console.log('Antes Submit', e);
			});
		});
	}

	cargaDatos(datos: any) {
		if (datos) {
			for (const campo in datos) {
				if (this.formulario.get(campo)) {

					// fix valor string cero
					if (this.formulario.get(campo)['tipo'] == 'toggle' || this.formulario.get(campo)['tipo'] == 'checkbox') {
						datos[campo] = (datos[campo] == '0' || datos[campo] == 0) ? false : datos[campo];
					}

					this.formulario.get(campo).patchValue(datos[campo]);
				}
			}
		}
	}

	reset() {
		this.formulario.reset();
	}

	establecer(e, dequien) {
		this.fnestablecido.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerChip(e, dequien) {
		this.fnchipChanges.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerFecha(e, dequien) {
		this.fncambiaFecha.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerMes(e, dequien) {
		this.formulario.get(dequien).patchValue({ 'desde': e.desde, 'hasta': e.hasta });
		this.fncambiaMes.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerSelect(e, dequien) {
		this.fncambiaSelect.emit({
			event: e,
			dequien: dequien
		});
	}

	get keys() {
		return Object.keys(this.formulario.controls);
	}

	getErrorMessage(name) {
		if (this.formulario.get(name).invalid) {
			return 'El campo ' + this.formulario.get(name)['attrs'].placeholder + ' es inválido';
		}
	}
	getControl(controlName): any {
		return (this.formulario as any).controls[controlName];
	}

	modifica(elemento, columna) {
		elemento.editando = true;
		if (columna.modificaDatos && columna.modificaDatos.procesa) {
			elemento = columna.modificaDatos.procesa(elemento, columna);
		}
		if (elemento === false) {
			return false;
		}
		let data: any = {
			value: elemento[columna.def],
			placeholder: columna.nombre,
			tipo: 'input'
		};
		data = columna.modificaDatos && columna.modificaDatos.datosBS ? Object.assign(data, columna.modificaDatos.datosBS) : data;
		if (columna.modificaDatos && columna.modificaDatos.busca) {
			data.busca = columna.modificaDatos.busca;
			data.tipo = 'autocomplete';
		} else if (columna.modificaDatos && columna.modificaDatos.datos) {
			data.resultados = columna.modificaDatos.datos();
			data.tipo = 'autocomplete';
		}
		if (!data.nombre) {
			data.nombre = 'value';
		}
		this.bottomSheet.open(InputBS, { data }).afterDismissed().subscribe((res) => {
			if (columna.modificaDatos && columna.modificaDatos.actualiza) {
				columna.modificaDatos.actualiza(elemento, columna, res);
			}
			elemento.editando = false;
		});
	}

}
